"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchRoutingAuditLogsAsyncV2 = void 0;
var typesafe_actions_1 = require("typesafe-actions");
exports.fetchRoutingAuditLogsAsyncV2 = (0, typesafe_actions_1.createAsyncAction)('@CONVERSATION_LOG/FETCH_ROUTING_AUDIT_LOGS_V2_REQUEST', '@CONVERSATION_LOG/FETCH_ROUTING_AUDIT_LOGS_V2_SUCCESS', '@CONVERSATION_LOG/FETCH_ROUTING_AUDIT_LOGS_V2_CANCEL', '@CONVERSATION_LOG/FETCH_ROUTING_AUDIT_LOGS_V2_FAIL')();